import React, { ReactNode, useState, useMemo, useEffect } from 'react'
import { SingleUseLinkData } from '@chilipiper/api-type-def/src/bookingLinks'
import { useRouteMatch } from 'react-router-dom'
import { createContextWithHook } from '@chilipiper/utils'
import { mapDataToContext, singleUselinkValidation } from './helpers'
import { useExchangeSingleUseLink } from './hooks/useExchangeSingleUseLink'

interface SingleUseLinkContext {
  isSingleUseLinkBooked?: boolean
  isSingleUseLinkExpired?: boolean
  isSingleUseLinkLoading?: boolean
  singleUseLinkData?: SingleUseLinkData
}

const { SingleUseLinkBaseProvider, useSingleUseLinkContext } =
  createContextWithHook<SingleUseLinkContext>()('SingleUseLink')
export { useSingleUseLinkContext }

interface Props {
  children: ReactNode
}

export const SingleUseLinkProvider = ({ children }: Props) => {
  const [singleUseLinkData, setSingleUseLinkData] = useState<SingleUseLinkData>({})
  const [isSingleUseLinkExpired, setSingleUseLinkExpired] = useState(false)
  const [isSingleUseLinkBooked, setSingleUseLinkBooked] = useState(false)
  const router = useRouteMatch()
  const [splat] = Object.values<string>(router.params)

  const singleUseLinkId = useMemo(() => {
    const [queue, id] = splat?.split('/') ?? []
    return queue === 'once' ? id : undefined
  }, [splat])

  const { data, isLoading } = useExchangeSingleUseLink(singleUseLinkId)

  useEffect(() => {
    if (data?.info) {
      const context = mapDataToContext(data)
      setSingleUseLinkData(context)
      setSingleUseLinkExpired(singleUselinkValidation.isExpired(data))
      setSingleUseLinkBooked(singleUselinkValidation.isBooked(data))
    }
  }, [data])

  if (isLoading) {
    return null
  }

  return (
    <SingleUseLinkBaseProvider
      value={{
        singleUseLinkData,
        isSingleUseLinkExpired,
        isSingleUseLinkBooked,
      }}
    >
      {children}
    </SingleUseLinkBaseProvider>
  )
}
